import { ReactNode } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import FFHModal from '@components/modal';
import Icon from '@components/atoms/icon';

type MobileToolSheetProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  footer?: ReactNode;
  children: ReactNode;
};

// The body scrolls on its own between a fixed header and footer, so content
// such as the ticker's gameweek row can stick to the top of the scroll area.
// The cap matches the modal's own max height.
const MobileToolSheet = ({
  isOpen,
  onClose,
  title,
  subtitle,
  footer,
  children
}: MobileToolSheetProps) => (
  <FFHModal
    open={isOpen}
    handleClose={onClose}
    title={title}
    isBottomSheetOnMobile
    hideCloseButton
    allowOverflow
    childrenClassName="outline-none md:w-[440px]"
  >
    <div className="flex max-h-[95vh] flex-col">
      <div className="flex items-start justify-between gap-3 border-b border-neutral-200 px-4 pb-3 pt-4">
        <div>
          <p className="m-0 font-sans text-[17px] font-semibold leading-6 text-neutral-800">
            {title}
          </p>
          {subtitle && (
            <p className="m-0 mt-0.5 font-open-sans text-xs text-neutral-600">
              {subtitle}
            </p>
          )}
        </div>
        <Dialog.Close
          aria-label="Close"
          data-cy="close-modal-button"
          className="-mr-1 -mt-1 rounded-full p-2 text-neutral-700 hover:bg-neutral-100"
        >
          <Icon name="Close" className="h-5 w-5" />
        </Dialog.Close>
      </div>
      <div
        className={`min-h-0 flex-1 overflow-y-auto px-4 ${
          footer ? 'pb-4' : 'pb-[max(16px,env(safe-area-inset-bottom))]'
        }`}
      >
        {children}
      </div>
      {footer && (
        <div className="border-t border-neutral-200 px-4 pt-3 pb-[max(12px,env(safe-area-inset-bottom))]">
          {footer}
        </div>
      )}
    </div>
  </FFHModal>
);

export default MobileToolSheet;
